<template>
    <ValidationObserver class="form" ref="form">
        <div>

            <ReferencesForm
                :user="user"
                @data-changed="updateForm"
            ></ReferencesForm>

            <div class="row">
                <div class="col-12 text-right ">
                    <div class="wrap-border-top">
                        <div class="btns-wrap">
                            <a href="/application-step-8"
                               class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                            <button
                                @click="save"
                                class="btn btn--secondary w-100 w-sm-auto"
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>

import ReferencesForm from "../CommonForms/ReferencesForm.vue";
import ApplicationFormService from "../services/ApplicationFormService";

export default {
    name: 'ApplicantFormStep9',
    components: {ReferencesForm},
    props: {
        user: {
            type: Object
        }
    },
    data() {
        return {
            dataFormStep9: {}
        }
    },
    methods: {
        save() {
            if (!Object.keys(this.dataFormStep9).length) {
                this.$showSuccessMessage();
                setTimeout(() => {
                    window.location.href = '/application-step-10';
                }, 1000)
            } else {
                (async () => {
                    const valid = await this.$refs.form.validate();

                    if (!valid) {
                        this.$showValidationErrorMessage();
                        return;
                    }
                    try {
                        const response = await ApplicationFormService.saveStep9(this.dataFormStep9);
                        if (response.status === 200) {
                            this.$showSuccessMessage();
                            setTimeout(() => {
                                window.location.href = '/application-step-10';
                            }, 1000)
                        }
                    } catch (error) {
                        this.$handleErrors(error)
                    }
                })();
            }
        },
        updateForm(dataReferencesForm) {
            this.dataFormStep9 = dataReferencesForm;
        }

    },
}

</script>

<style scoped>

</style>
